import React from "react";
import coins from "../../../assets/icon/coins.png";
import user from "../../../assets/icon/user.png";
import wallet from "../../../assets/icon/wallet.png";
import items from "../../../assets/icon/item.png";
import { useEffect, useState, useContext } from "react";
import { toast } from "react-hot-toast";
import { expertContext } from "../../../context/expertcontext";
import Num2persian from "num2persian";
import {
  clearingPriceExpertWallet,
  getAdminExpertWallet,
} from "../../../services/adminServices";
import { useParams } from "react-router-dom";

const ExpertWallet = () => {
  const [info, setInfo] = useState({});
  const [list, setList] = useState([]);
  const [price, setPrice] = useState("");
  const { setPage } = useContext(expertContext);
  const { id } = useParams();

  const Checkout = async () => {
    try {
      const clearingPrice = document.getElementById("clearingPrice").value;
      const trackingCode = document.getElementById("trackingCode").value;
      const sendData = {
        clearingPrice,
        trackingCode,
        expertToken: id,
        currentWallet: info.wallet,
      };
      console.log(sendData);
      if (trackingCode && clearingPrice) {
        const { data } = await clearingPriceExpertWallet(sendData);
        console.log(data);
        toast.success("درخواست با موفقیت انجام شد");
        document.getElementById("clearingPrice").value = "";
        document.getElementById("trackingCode").value = "";
      } else {
        toast.error("لطفا مقادیر را وارد کنید");
      }
    } catch (err) {
      console.log(err);
      toast.error("درخواست شما نجام نشد لطفا مجددا امتحان کنید");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setPage("کیف پول");
        const { data } = await getAdminExpertWallet(id);
        console.log(data);
        setInfo(data.result);
        setList(data.result.Ex_Expertsـtransactions);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);
  return (
    <div>
      <div className="row g-0 w-100 mt-3 justify-content-around">
        <div className="col-xl-4 col-lg-5 col-md-5 col-12  row">
          <div className="col-sm-6 pb-0 col-md-12  mb-1">
            <div
              className=" wallet-item"
              style={{ backgroundColor: "rgba(255, 166, 0, 0.5)" }}
            >
              <div className="">
                <img alt="" src={coins} />
                <p className="mb-0">موجودی</p>
              </div>
              <div>
                <strong>{info.wallet?.toLocaleString()}</strong>
                <small>تومان</small>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-12  mb-1">
            <div
              className="wallet-item"
              style={{ backgroundColor: "rgba(115, 159, 177, 0.5)" }}
            >
              <div className="text-end">
                <img alt="" src={user} height="50px" />
                <p>تعداد کارشناسی</p>
              </div>
              <strong>{info.bachlorCount}</strong>
            </div>
          </div>
          <div className="col-sm-6 col-md-12  mb-1">
            <div
              className="wallet-item"
              style={{ backgroundColor: "rgba(223, 198, 151, 0.5)" }}
            >
              <div className="text-end">
                <img alt="" src={items} />
                <p>جمع برداشت</p>
              </div>
              <div>
                <strong>{info.totalDecrease}</strong>
                <small>تومان</small>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-12  mb-1">
            <div
              className="wallet-item"
              style={{ backgroundColor: "rgba(223, 198, 151, 0.5)" }}
            >
              <div className="text-end">
                <img alt="" src={wallet} />
                <p>جمع واریز</p>
              </div>
              <div>
                <strong>{info.totalInCrease}</strong>
                <small>تومان</small>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-5 col-lg-5 col-md-5 col-12 row">
          <div className="col-12 col-md-12  mb-1">
            <div className="col-12 col-md-12  mb-1">
              <div className="wallet-list-box">
                <p
                  className="wallet-list-item"
                  style={{ backgroundColor: "#b2d9bd" }}
                >
                  لیست واریزی ها
                </p>
                <div className="wallet-item-box">
                  {info.inCreaseTrnx &&
                    info.inCreaseTrnx.map((i, index) => (
                      <div
                        key={index}
                        className="wallet-list-item mb-2"
                        style={{ backgroundColor: "#b2d9bd" }}
                      >
                        <div className="d-flex  justify-content-between">
                          <p className="mb-0">{i.value}</p>
                          <p className="mb-0">{i.fa_date}</p>
                        </div>
                        <p className="mb-0 text-end">
                          بابت صورت کارشناسی : {i.requestToken}-{i.reason == "Bachlor-PrePayment"? "پیش پرداخت" : "صدور صورت"}
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-12  mb-1">
            <div className="wallet-list-box">
              <p
                className="wallet-list-item"
                style={{ backgroundColor: "#FFDA94" }}
              >
                لیست برداشت ها
              </p>
              <div className="wallet-item-box">
                {info.deCreaseTrnx &&
                  info.deCreaseTrnx.map((i, index) => (
                    <div
                      className="mb-2 wallet-list-item"
                      key={index}
                      style={{ backgroundColor: "#FFDA94" }}
                    >
                      <div className="d-flex  justify-content-between">
                        <p className="mb-0">{i.value}</p>
                        <p className="mb-0">{i.fa_date}</p>
                      </div>
                      <p className="mb-0 text-end">
                        {/* شماره پیگیری تراکنش: {i.trackingCode} */}
                        {i.reason == "Site-Commission" ? "کمیسیون سایت صورت کارشناسی: ":"شماره پیگیری تراکنش"} − {i.reason == "Site-Commission"? i.requestToken:i.trackingCode}
                      </p>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" w-100 mt-3 py-2 px-4 admin-expert-panel-clearing-box">
        <p className="text-end">
          <strong>برداشت از کیف پول</strong>
        </p>
        <div className="row g-2">
          <div className="col-6 ">
            <input
              className="admin-expert-panel-clearing-input"
              id="clearingPrice"
              placeholder="مبلغ مورد نظر برای برداشت را وارد کنید"
              onChange={(e) => {
                setPrice(e.target.value);
              }}
            />
            {price && <p className="text-end">{Num2persian(price)} تومان</p>}
          </div>
          <div className="col-4 ">
            <input
              className="admin-expert-panel-clearing-input"
              id="trackingCode"
              placeholder="کد پیگیری"
            />
          </div>
          <div className="col-2 ">
            <button
              className="admin-expert-panel-clearing-btn btn"
              onClick={() => {
                Checkout();
              }}
            >
              تسویه
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpertWallet;
